import { getParam } from "./urls";

const isHeadless = () =>
  getParam(window.location, "source") === "headless" ||
  navigator.userAgent === "OpenCounter:generatePDF.js";

export default isHeadless;
